(ns frontend.ui.page.lp-report-editor.style
  (:require
   [frontend.ui.style.theme.core :as theme]))

(defn page-container-loading
  []
  {:display         "flex"
   :justify-content "center"
   :align-items     "center"
   :flex-flow       "column"
   :height          "100vh"
   :width           "100%"
   :background      (theme/color [:lp-editor :page :background])})

(defn no-data
  []
  {:display        "flex"
   :flex-direction :column
   :justify-content :center
   :align-items    :center
   :gap            "32px"})

(defn img
  []
  {:max-width     "300px"
   :margin-bottom "30px"})

(defn page-container
  []
  {:display     "flex"
   :font-family (theme/font-families :primary)
   :flex-flow   "column"
   :flex        "0 0 100%"
   :overflow    "auto"
   :background  (theme/color [:layout :primary :bg])})

(defn header
  []
  {:display         "flex"
   :flex            "0 0 auto"
   :flex-flow       "column"
   :align-items     "center"
   :justify-content "center"
   :padding         "16px 16px 0"
   :background      (theme/color [:lp-editor :header :background])
   :z-index         0})

(defn page-body
  []
  {:flex           "1 1 100%"
   :overflow-x     "hidden"
   :padding        "0 16px 24px"
   :display        :flex
   :flex-direction :column
   :align-items    :center
   :z-index        0
  })

(defn page-watermark-container
  []
  {:position   "absolute"
   :left       0
   :top        "130px"
   :overflow   "hidden"
   :right      0
   :bottom     0
   :z-index    0
   :border-top "1px solid #CCC"
  })

(defn page-watermark
  []
  {:position  "relative"
   :left      "-50%"
   :top       "-50%"
   :width     "200%"
   :height    "200%"
   :font-size "35px"
   :color     (theme/color [:lp-editor :page :data-watermark])
   :transform "rotate(-45deg)"
  })

(defn page-content
  []
  {:width     :100%
   :max-width :1140px})

